import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetBankAccountListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    selectedBanks: CustomMultiSelectModel[]
    selectedCurrencyTypes: CustomMultiSelectModel[]
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetBankAccountListPagingAndFilterRequest: GetBankAccountListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedBanks: [],
    selectedCurrencyTypes: [],
    columnFilters: []
}